import {Component, inject, input, output} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgOptimizedImage} from "@angular/common";
import {HttpClient} from "@angular/common/http";
import {InHubMessage} from '../../models/inHubMessage';
import {RepoHubService} from '../../services/repo-hub.service';
import {MatDrawerContainer} from '@angular/material/sidenav';
import {Bu} from '../../models/bu';
import {urlValidator} from "../../shared/custom-validators";

@Component({
  selector: 'app-create-in-hub-message-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDrawerContainer,
    NgOptimizedImage
  ],
  templateUrl: './create-in-app-message-hub-dialog.component.html',
  styleUrl: './create-in-app-message-hub-dialog.component.scss'
})
export class CreateInHubMessageDialogComponent {

  hubRoutes = [
    {text: 'All', value: 'all'},
    {text: 'Startpage', value: 'startPage'},
    {text: 'Create Subscription', value: 'createSubscription'},
    {text: 'Bulk Import', value: 'bulkImport'},
    {text: 'Subscription Overview', value: 'subscriptionOverview'},
    {text: 'Subscription Statistics', value: 'subscriptionStatistics'},
    {text: 'Site Overview', value: 'siteOverview'},
    {text: 'Site Statistics', value: 'siteStatistics'},
    {text: 'Invoices', value: 'invoices'},
    {text: 'My Account', value: 'myAccount'},

  ]

  onBackClick = output();

  onSubmitClick = output();
  bus = ["uk", "se", "no", "de"];
  http = inject(HttpClient)
  allForm = new FormGroup({
    englishTitle: new FormControl(""),
    swedishTitle: new FormControl(""),
    englishMessage: new FormControl("", Validators.required),
    swedishMessage: new FormControl("", Validators.required),
    englishLabel: new FormControl(""),
    swedishLabel: new FormControl(""),
    dismissible: new FormControl(false),
    link: new FormControl(false),
    linkLabel: new FormControl(null),
    externalUrl: new FormControl(null, this.validateUrlFormat),
    displayRoute: new FormControl('all'),
  }, urlValidator());
  data = input<{
    bu: "se",
    currentInHubMessage: InHubMessage,
  }>()
  protected readonly Bu = Bu;

  constructor(public repo: RepoHubService) {

  }

  ngOnInit(): void {
    if (this.data().currentInHubMessage) {
      this.autoFillTranslations(this.data().currentInHubMessage)
    }
  }


  autoFillTranslations(currentInHubMessage: InHubMessage) {
    this.allForm.controls.externalUrl.setValue(currentInHubMessage.externalUrl ?? "")
    this.allForm.controls.dismissible.setValue(currentInHubMessage.dismissible ?? false)
    this.allForm.controls.displayRoute.setValue(currentInHubMessage.displayRoute ?? '')

    this.allForm.controls.englishTitle.setValue(currentInHubMessage.titles.en_GB ?? "")
    this.allForm.controls.englishMessage.setValue(currentInHubMessage.messages.en_GB ?? "")
    this.allForm.controls.englishLabel.setValue(currentInHubMessage.linkText.en_GB ?? "")

    this.allForm.controls.swedishTitle.setValue(currentInHubMessage.titles.sv_SE ?? "")
    this.allForm.controls.swedishMessage.setValue(currentInHubMessage.messages.sv_SE ?? "")
    this.allForm.controls.swedishLabel.setValue(currentInHubMessage.linkText.sv_SE ?? "")

  }

  validateUrlFormat(control: AbstractControl): { [key: string]: any } | null {
    if (control.value && !/^((https?):\/\/)(([\da-z.-]+)\.([a-z.]{2,6})([\/\w.-]*)*\/?)(\?.*)?$/.test(control.value)) {
      return {'invalidUrlFormat': true};
    }
    return null;
  }

  async createMessage() {
    let message: InHubMessage | null = null;
    let titles = [this.allForm.value.englishTitle, this.allForm.value.swedishTitle];
    let messages = [this.allForm.value.englishMessage, this.allForm.value.swedishMessage];
    let linkText = [this.allForm.value.englishLabel, this.allForm.value.swedishLabel];
    if (this.allForm.valid) {
      message = new InHubMessage(null,
        {en_GB: titles[0], sv_SE: titles[1]},
        {en_GB: messages[0], sv_SE: messages[1]},
        {en_GB: linkText[0], sv_SE: linkText[1]},
        this.allForm.value.externalUrl ?? null,
        this.allForm.value.dismissible ?? null,
        this.data().bu,
        this.allForm.value.displayRoute,
        new Date(),
        localStorage.getItem('userName'));


      if (this.data().currentInHubMessage != null) {
        await this.repo.removeInHubMessage();
      }
      if (message) {
        await this.repo.createInHubMessage(message);
      }
    }
  }


  async translateWithAI() {
    if (this.allForm.controls.englishMessage.value) {
      this.translate("en");
    } else if (this.allForm.controls.swedishMessage.value) {

      this.translate("sv");
    } else {
      return;
    }
  }

  translate(sourceLanguage: string) {
    let title: string;
    let message: string;
    let label: string;
    switch (sourceLanguage) {
      case "en":
        title = this.allForm.controls.englishTitle.value;
        message = this.allForm.controls.englishMessage.value;
        label = this.allForm.controls.englishLabel.value;
        break;

      case "sv":
        title = this.allForm.controls.swedishTitle.value;
        message = this.allForm.controls.swedishMessage.value;
        label = this.allForm.controls.swedishLabel.value;
        break;
    }


    console.log(title, message, label)
    // $ - is a wild character and used to split between parts
    this.repo.translateText(title + " $ " + message + " $ " + label).then(res => {
      let translations = res.map(r => {
        return r.data["translations"][0];
      }) as {
        detectedSourceLanguage: string,
        translatedText: string
      }[]


      for (let i = 0; i < translations.length; i++) {

        let textArray: string[] = translations[i].translatedText.split(" $ ")
        title = textArray[0];
        message = textArray[1];
        label = textArray[2];

        if (i == 0) {
          this.allForm.controls.englishTitle.setValue(title)
          this.allForm.controls.englishMessage.setValue(message)
          this.allForm.controls.englishLabel.setValue(label)
        }
        if (i == 1) {
          this.allForm.controls.swedishTitle.setValue(title)
          this.allForm.controls.swedishMessage.setValue(message)
          this.allForm.controls.swedishLabel.setValue(label)
        }
      }
    })
  }

}
